import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from "vue-property-decorator";
import Crumb from "../components/Crumb.vue";
import PaperInfo from "../components/PaperInfo.vue";
import PaperOrganize from "../components/PaperOrganize.vue";
import QuestionEdit from "../../question/edit/index.vue";
import MaterialQuestionEdit from "../../question/material-edit/index.vue";
import { TestPaperEditorModule } from "@/store/modules/test-paper-editor";
import { checkSession } from "@/api/commom";
import eventEmitter from "@/utils/eventEmitter";
let TestPaperEdit = class TestPaperEdit extends Vue {
    constructor() {
        super(...arguments);
        this.step = 1;
        this.editingQuestion = false;
        this.editingMaterialQuestion = false;
        this.gooseClass = false;
        this.aliveInterval = null;
        this.shouldDialogShow = true;
    }
    get paperId() {
        return TestPaperEditorModule.paperId;
    }
    get baseInfo() {
        return TestPaperEditorModule.baseInfo;
    }
    get gloableLoading() {
        return TestPaperEditorModule.gloableLoading;
    }
    handleRouteChange(route) {
        this.step = route.query.step ? Number(route.query.step) : 1;
        if (route.query.question_id && route.query.is_edit) {
            this.editingQuestion = true;
            this.editingMaterialQuestion = 6 == Number(route.query.type);
        }
        else {
            this.editingQuestion = false;
        }
    }
    created() {
        // const type = this.$route.query.type as string;
        // if ("goose" === type) {
        //   this.gooseClass = true;
        // }
        this.initData();
        this.$bus.$on("edit-question-of-paper-success", this.editSuccessFun);
        this.aliveInterval = setInterval(() => {
            checkSession();
        }, 30 * 1000);
        eventEmitter.on('routerRapture', () => this.shouldDialogShow ? Promise.reject() : Promise.resolve());
    }
    beforeDestroy() {
        clearInterval(this.aliveInterval);
    }
    initData() {
        TestPaperEditorModule.resetState();
        const newQuery = {
            step: 1
        };
        const query = this.$route.query;
        const paperId = query.paper_id;
        const step = query.step;
        const examId = query.exam_id;
        // console.log(paperId, step, examId, "初始化")
        if (paperId) {
            // TestPaperEditorModule.setPaperId(paperId)
            newQuery.paper_id = paperId;
            if (examId) {
                newQuery.step = Number(step) || 1;
                newQuery.exam_id = examId;
                this.step = Number(step);
            }
            TestPaperEditorModule.getPaperDetail(paperId);
        }
        this.$router.push({
            query: newQuery
        });
    }
    editSuccessFun(questionId) {
        const newQuery = {
            step: this.$route.query.step || 2,
            paper_id: this.$route.query.paper_id,
            exam_id: this.$route.query.exam_id || ''
        };
        this.$router.push({
            name: "TestPaperEdit",
            query: newQuery
        });
        TestPaperEditorModule.updateEditQuestion(questionId);
    }
    routeBack() {
        this.shouldDialogShow = false;
        this.$router.push({ name: "TestPaper" });
    }
};
tslib_1.__decorate([
    Watch('$route')
], TestPaperEdit.prototype, "handleRouteChange", null);
TestPaperEdit = tslib_1.__decorate([
    Component({
        name: 'TestPaperEdit',
        components: {
            Crumb,
            PaperInfo,
            PaperOrganize,
            AddMaterialQuestion: MaterialQuestionEdit,
            AddQuestion: QuestionEdit
        },
    })
], TestPaperEdit);
export default TestPaperEdit;
